import React, { FC } from "react";
import { IInputProps } from "../../../modules/form";

export const InputTextArea: FC<IInputProps> = ({ onChange, onTouched, value, defaultValue, placeholder }) => {
  return (
    <textarea
      onChange={(e) => onChange(e.target.value)}
      onBlur={() => onTouched()}
      value={value}
      placeholder={placeholder}
    />
  );
};
